export default "__VITE_ASSET__BZtnnGih__"